import { componentRef } from './consts';

export default function (editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  if (options.blocks.indexOf(componentRef) >= 0) {
    bm.add(componentRef, {
      label: `
      <i class="webconnect-search"></i>
      <div class="gjs-block-label">${options.labelTable}</div>
      `,
      category: options.labelTypesenseSearchCategory,
      content: `
         <div class="form-group col-12 col-md-12 typensense-search" data-gjs-type="typesense-search" data-typesense-search-component>
            <label for="search">Typesense Search</label>
            <input type="text" 
                id="typesense-search" 
                name="search" 
                placeholder="Search..." 
                class="form-control input--style" />
            <div id="typesense-results-container" typesense-results-container>
                <ul id="typesense-results" class="typesense-dropdown">
                  <li id="typesense-list" class="list-group-item bg-light border rounded shadow-sm p-2">
                    <a id="typesense-anchor" class="text-decoration-none text-dark d-block w-100 p-2 rounded" href="#">
                      Result 1
                    </a>
                  </li>
                </ul>
            </div>
             <div id="typesense-pagination" class="text-center mt-3">
                <button id="typesensePrevPage" class="btn btn-primary mx-2">Previous</button>
                <span id="typesenseCurrentPage" class="align-self-center">Page 1</span>
                <button id="typesenseNextPage" class="btn btn-primary mx-2">Next</button>
             </div>
         </div>
              `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
          ${model.get('label')}
        </div>
      `,
    });
  }
}
